module.exports = __webpack_public_path__ + "static/media/Setting-icon.afb19dd0.svg";